<h2 mat-dialog-title class="dialog-title">Remove Item from Cart?</h2>
<mat-dialog-content class="dialog-content">
  <p>Are you sure you want to remove this item from your cart? This action cannot be undone.</p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button color="primary" class="go-back-btn" (click)="onGoBack()">
    <mat-icon>arrow_back</mat-icon>
    GO BACK
  </button>
  <button mat-flat-button color="warn" class="remove-btn" (click)="onRemove()">
    <mat-icon>delete</mat-icon>
    REMOVE
  </button>
</mat-dialog-actions>
